module.exports = __webpack_public_path__ + "static/avatar-6c07bb9dd7208560d8d4e7ccefe3cf44.jpg";